import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ApiResult} from "../../models/api-result.models";

@Injectable({
    providedIn: 'root'
})
export class EmailService {

    public urlBase = environment.urlApi;

    constructor(
        private httpClient: HttpClient,
    ) {

    }

    sendEmailByTemplate(tipo_template: string) {

        const request = {
            tipo_template
        };

        return this.httpClient.post<ApiResult>(this.urlBase + '/send-email-by-template', request);
    }

}
